import { render, staticRenderFns } from "./CrazyCategory.vue?vue&type=template&id=477233a6&"
import script from "./CrazyCategory.vue?vue&type=script&lang=js&"
export * from "./CrazyCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports